import { render, staticRenderFns } from "./full-list.vue?vue&type=template&id=235009a8&scoped=true&"
import script from "./full-list.vue?vue&type=script&lang=js&"
export * from "./full-list.vue?vue&type=script&lang=js&"
import style0 from "./full-list.vue?vue&type=style&index=0&id=235009a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235009a8",
  null
  
)

export default component.exports